import React, {useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../../actions/ApiGo';

const Connection_His =(props)=>{
    const {t}=useTranslation()
    const [login_Row, setLogin_Row] = useState([]);
    const [logout_Row, setLogout_Row] = useState([]);
    const [mix_row, setMix_row] = useState([]);
    useEffect(()=>{
        fetch_device_connection_login()
        fetch_device_connection_logout()
        function fetch_device_connection_login(){
            return new Promise(()=>{
                ApiGo.getDevice_connection_record_login()
                .then(res=>{
                    let res_arr = res.filter(row=>{
                        row.created_at = Date.parse(row.created_at)
                        row.login_time =row.login_time.split("T")[0] + " " + row.login_time.split("T")[1]
                        // if(row.user_name===props.name){ return row }
                        return (row.user_name===props.name)?row:null
                    })
                    setLogin_Row(res_arr)
                })
                .catch(err=>{console.log(err);})
            })
        }
        function fetch_device_connection_logout(){
            return new Promise((resoleve, reject)=>{
                ApiGo.getDevice_connection_record_logout()
                .then(res=>{
                    let res_arr = res.filter(row=>{
                        row.created_at = Date.parse(row.created_at)
                        row.logout_time =row.logout_time.split("T")[0] + " " + row.logout_time.split("T")[1]
                        if(row.user_name===props.name){ return row }
                    })
                    setLogout_Row(res_arr)
                })
                .catch(err=>{console.log(err);})
            })
        }
    },[])

    useEffect(()=>{
        let arr = login_Row.concat(logout_Row)
        arr.sort((a,b)=>{
            if(a.created_at < b.created_at) return 1
            if(b.created_at < a.created_at) return -1
            return 0;
        })
        setMix_row(arr)
    }, [login_Row, logout_Row])


    return(
        <div className="font-ml">
            <div className="font-l">{t("ADMIN.CONNECTION_HIS")}</div>
            <div className="fx-d-r wid-admin-90 fx-cspar">
                <div className="wid-admin-s fx-cc">{t("NAV_BAR.USERS")}</div>
                {/* <div>名</div> */}
                <div className="wid-admin-s fx-cc">{t("GLOBAL.INSTITUTION")}</div>
                <div className="wid-admin-s fx-cc">{t("ADMIN.CONNECTION_HIS_PAGE.TYPE")}</div>
                <div className="wid-admin-s fx-cc">{t("ADMIN.CONNECTION_HIS_PAGE.OS")}</div>
                <div className="wid-admin-s fx-cc">{t("ADMIN.CONNECTION_HIS_PAGE.OS_VERSION")}</div>
                <div className="wid-admin-s fx-cc">{t("GLOBAL.LOGIN")}/{t("AUDIT_TRAIL.EVENTS.LOGOUT")}</div>
                <div className="wid-admin-15 fx-cc">{t("ADMIN.INDEX.UPDATED_TIME")}</div>
            </div>
            {mix_row.map((row,index)=>{
                return <ConnectionHisrow row={row} index={row.login_time} key={index}/>
            })}
        </div>
    );	

}
export default Connection_His;


const ConnectionHisrow =(props)=>{
    const {t}=useTranslation()
    let row = props.row
    return(
        <div className="fx-d-r wid-admin-90 fx-cspar">
            <div className="wid-admin-s fx-cc">{row.user_name}</div>
            <div className="wid-admin-s fx-cc">{row.institution}</div>
            <div className="wid-admin-s fx-cc">{row.type}</div>
            <div className="wid-admin-s fx-cc">{row.os}</div>
            <div className="wid-admin-s fx-cc">{row.os_version}</div>
            {(row.login_time!==undefined)? <div className="wid-admin-s fx-cc"><div className="h-5 wid-admin-xs br-10 margt-xs fx-cc bgC-green">{t("GLOBAL.LOGIN")}</div></div>:null}
            {(row.logout_time!==undefined)? <div className="wid-admin-s fx-cc"><div className="h-5 wid-admin-xs br-10 margt-xs fx-cc bgC-alert-EE ">{t("AUDIT_TRAIL.EVENTS.LOGOUT")}</div></div>:null}
            {(row.login_time!==undefined)? <div className="wid-admin-15 fx-cc">{row.login_time}</div>:null}
            {(row.logout_time!==undefined)? <div className="wid-admin-15 fx-cc">{row.logout_time}</div>:null}
        </div>        
    );	

}